// @flow
import * as React from 'react';
import styled from 'styled-components';
import {ButtonImage} from './Image';
import {ButtonSizeL, ButtonSizeM} from './Constants.js';

export type PropsButton = {
  source: string,
  sourceMobile?: string,
  onClick?: () => void,
  dataHidden?: boolean,
}

const ButtonIconL: React.AbstractComponent<PropsButton> = styled(ButtonImage)`
  width: ${(props: any) => props.theme.layout.scale * (!props.theme.layout.mobile ? ButtonSizeL.desktop : ButtonSizeL.mobile)}px;
  height: ${(props: any) => props.theme.layout.scale * (!props.theme.layout.mobile ? ButtonSizeL.desktop : ButtonSizeL.mobile)}px;
`;

const ButtonIconM: React.AbstractComponent<PropsButton> = styled(ButtonImage)`
  width: ${(props: any) => props.theme.layout.scale * (!props.theme.layout.mobile ? ButtonSizeM.desktop : ButtonSizeM.mobile)}px;
  height: ${(props: any) => props.theme.layout.scale * (!props.theme.layout.mobile ? ButtonSizeM.desktop : ButtonSizeM.mobile)}px;
`;

// const ButtonIconS: React.AbstractComponent<PropsButton> = styled(ButtonImage)`
//   width: ${(props: any) => props.theme.layout.scale * (props.theme.layout.sizeL ? 44 : 36)}px;
//   height: ${(props: any) => props.theme.layout.scale * (props.theme.layout.sizeL ? 44 : 36)}px;
// `;

type Props = {
  source: string,
  sourceMobile?: string,
  onClick?: () => void,
  dataHidden?: boolean
}

const ButtonIconInDivS: React.AbstractComponent<Props, any> = React.forwardRef<Props, any>((props: Props, ref: any) =>  {
  const {onClick, source, sourceMobile, ...others} = props;
  return <ButtonWrapper {...others}>
    <ButtonIconL source={source} sourceMobile={sourceMobile} onClick={onClick} />
  </ButtonWrapper>;
});

const ButtonWrapper = styled.div`
  opacity: ${(props: any) => (props.dataHidden ? 0 : undefined)};
  transition: opacity ${(props: any) => props.theme.defaults.transitionDuration}s;

  > button {
    pointer-events: ${(props: any) => props.dataHidden ? 'none' : undefined};
  }
`

export {ButtonIconL, ButtonIconM, ButtonIconInDivS}
